import React from 'react'

import { Formik, Form } from 'formik'

import { Button, Stack } from '@mui/material'

import { useAuth } from '@/hooks/useAuth'

import { cardFormInitialValues, cardFormValidationSchema } from './types'
import { useCardAddFormSubmit } from './useCardAddFormSubmit'
import { useMissingProfile } from './useMissingProfile'
import { CardFormFields } from './CardFormFields'

export { CardFormFields } from './CardFormFields'
export { cardFormInitialValues, cardFormValidationSchema } from './types'
export type { CardFormData } from './types'
export { useCardAddFormSubmit } from './useCardAddFormSubmit'
export { useMissingProfile } from './useMissingProfile'

export interface CardAddFormProps {
  onSuccess: (cardId?: number) => void
}

export const CardAddForm: React.FC<CardAddFormProps> = ({ onSuccess }) => {
  const { user } = useAuth()
  const handleSubmit = useCardAddFormSubmit(onSuccess)
  const missingProfile = useMissingProfile()

  return (
    <Formik initialValues={cardFormInitialValues} validationSchema={cardFormValidationSchema} onSubmit={handleSubmit}>
      {({ submitForm, isSubmitting }) => (
        <Form>
          <Stack direction="column" spacing={3}>
            <CardFormFields />
            <Button
              variant="contained"
              color="primary"
              onClick={submitForm}
              loading={isSubmitting}
              disabled={isSubmitting || !user?.phone || missingProfile.length > 0}
              sx={{ borderRadius: 20 }}
            >
              Adicionar
            </Button>
          </Stack>
        </Form>
      )}
    </Formik>
  )
}
